export default __webpack_public_path__ + "static/media/grid_2__02.f7e24309.jpg";